// extracted by mini-css-extract-plugin
export default {"container":"InfoContainer_container__x1dXa","headerContainer":"InfoContainer_headerContainer__uKDRo"};